import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { WorkshopContext } from "../contexts/workshop.context";
import { Button, ScenarioBox } from "../components/workshop";

import logo from "../assets/images/logo.png";
import lynnImage from "../assets/images/lynn-to-right.png";
import { defaultRoles } from "../util/workshop.util";

const DEMO_WORKSHOP_IDS = {
  en: "675aa29f82fcb8dbb783e18d", // Default/English workshop ID
  fr: "679b4d34228a44092f4e78ca",
  de: "679cb402228a44092f4e78cb",
  it: "675aa29f82fcb8dbb783e18d"
};

const PreSummary = ({ demoWorkshop = false }) => {
  const { t, i18n } = useTranslation();

  const { user: { role } = {}, workshopDetails: { _id, teamName, mftPublic } = {} } =
    useContext(WorkshopContext);

  // If someone is landing here without being part of workshop
  useEffect(() => {
    if (_id && teamName && !role) {
      window.location.href = demoWorkshop ? "/insights/demo" : `/insights/${_id}`;
    }
  }, [_id, teamName]);

  return (
    <section id="presummary" className="relative max-w-2xl mx-auto flex flex-col gap-4">
      <img
        src={t("preSummary.lynnImage")}
        alt="lynn"
        className="w-80 mx-auto absolute -left-36 -top-12 z-10"
      />

      <div className={`relative z-20 ${demoWorkshop ? "flex flex-col gap-12" : ""}`}>
        <img src={logo} alt="logo" className="w-24 mx-auto mt-10" />
        {!demoWorkshop ? (
          <>
            {mftPublic ? (
              <>
                <h3
                  className="font-medium text-orange-100 text-center font-righteous text-3xl"
                  dangerouslySetInnerHTML={{ __html: teamName }}
                />

                <h1
                  dangerouslySetInnerHTML={{ __html: t("mftPublicPreSummary.heading") }}
                  className="text-5xl font-medium font-righteous text-gray-250 mt-4"
                />
                <p
                  dangerouslySetInnerHTML={{ __html: t("mftPublicPreSummary.subheading") }}
                  className="text-xl text-gray-250 font-medium"
                />
                <p
                  dangerouslySetInnerHTML={{ __html: t("mftPublicPreSummary.description") }}
                  className="text-xl text-gray-100 mb-4"
                />
              </>
            ) : (
              <>
                <h3
                  className="font-medium text-orange-100 text-center font-righteous text-3xl"
                  dangerouslySetInnerHTML={{ __html: teamName }}
                />

                {role === defaultRoles.participant && (
                  <>
                    <h1
                      dangerouslySetInnerHTML={{ __html: t("preSummary.heading") }}
                      className="text-5xl font-medium font-righteous text-gray-250 mt-4"
                    />
                    <p
                      dangerouslySetInnerHTML={{ __html: t("preSummary.subheading") }}
                      className="text-xl text-gray-250 font-medium"
                    />
                    <p
                      dangerouslySetInnerHTML={{ __html: t("preSummary.description") }}
                      className="text-xl text-gray-100 mb-4"
                    />
                  </>
                )}

                {role === defaultRoles.moderatorAndParticipant && (
                  <>
                    <h1
                      dangerouslySetInnerHTML={{
                        __html: t("preSummary.heading1")
                      }}
                      className="text-5xl font-medium font-righteous text-gray-250 mt-4"
                    />
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("preSummary.subheading1")
                      }}
                      className="text-xl text-gray-250 font-medium"
                    />
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("preSummary.description1")
                      }}
                      className="text-xl text-gray-100 mb-4"
                    />
                  </>
                )}

                {role === defaultRoles.moderator && (
                  <>
                    <h1
                      dangerouslySetInnerHTML={{ __html: t("preSummary.heading2") }}
                      className="text-5xl font-medium font-righteous text-gray-250 mt-4"
                    />
                    <p
                      dangerouslySetInnerHTML={{ __html: t("preSummary.subheading2") }}
                      className="text-xl text-gray-250 font-medium"
                    />
                    <p
                      dangerouslySetInnerHTML={{ __html: t("preSummary.description2") }}
                      className="text-xl text-gray-100 mb-4"
                    />
                  </>
                )}
              </>
            )}
          </>
        ) : (
          <>
            <h1
              dangerouslySetInnerHTML={{
                __html: t("preSummary.heading")
              }}
              className="text-5xl font-medium font-righteous text-gray-250 mt-20"
            />
            <p
              dangerouslySetInnerHTML={{
                __html: t("preSummary.description")
              }}
              className="text-xl text-gray-100 mb-4"
            />
            <ScenarioBox text={t("preSummary.scenario")} />
          </>
        )}

        <Button
          text={t("preSummary.button")}
          onClick={() => {
            if (demoWorkshop) {
              const demoWorkshopId = DEMO_WORKSHOP_IDS?.[i18n.language] || DEMO_WORKSHOP_IDS?.en;

              const demoUrl = `${window.location.origin}/insights/${demoWorkshopId}?demo=true`;
              // Only send postMessage if we're in an iframe
              if (window !== window.parent) {
                window.parent.postMessage({ type: "NAVIGATE", url: demoUrl }, "*");
              } else {
                window.location.href = demoUrl;
              }
            } else {
              window.location.href = `/insights/${_id}`;
            }
          }}
        />
      </div>
    </section>
  );
};

export default PreSummary;
